import { MenuItem } from "../core/type";
import { translate } from "../core";
import { AppraisalIcon, WarehouseIcon, WeddingIcon, } from "../component/icon";
import {
  BarChartOutlined,
  CloudUploadOutlined,
  ContactsOutlined,
  SettingFilled,
  ShoppingOutlined,
  ToolOutlined,
  DollarOutlined
} from '@ant-design/icons'
import { MenuLink } from '../core/until'
import { AppointmentMenuIcon, AppointmentMenuItem } from '../app/appointment/component/AppointmentMenuItem'
import { TicketMenuIcon, TicketMenuItem } from '../app/ticket/component/TicketMenuItem'
import { OnlineOrderMenuIcon, OnlineOrderMenuItem } from '../app/order/component/OnlineOrderMenuItem'
import {
  PurchaseOrderMenuIcon,
  PurchaseOrderMenuLabel,
  ReceivedBackOrderMenuItem,
} from '../app/inventory/component/ReceivedBackOrderMenuItem'

export const menuItems: MenuItem[] = [
  {
    label: translate("appraisal"),
    key: "2",
    path: "/appraisal",
    icon: <AppraisalIcon size={20}/>,
  },
  {
    label: translate("inventory"),
    key: "3",
    path: "/inventory",
    icon: <WarehouseIcon size={20} href="/inventory"/>,
    children: [
      {
        label: (
          <MenuLink
            title={translate("stone", "inventory", "management")}
            to="/reports/stone-inventory-management"
          />
        ),
        key: "inventory-stone-management",
        path: "",
      },
      {
        label: (
          <MenuLink
            title={translate("inventory", "by", "pattern")}
            to="/reports/inventory-by-pattern"
          />
        ),
        key: "11-4",
        path: "",
      },
    ]
  },
  {
    label: translate("contact"),
    key: "4",
    path: "/contact",
    icon: <ContactsOutlined style={{fontSize: 20, color: "#a3bde3"}}/>,
  },
  {
    label: translate('order'),
    key: '5',
    path: '/order',
    icon: <ShoppingOutlined style={{fontSize: 23, color: '#a3bde3'}}/>,
  },
  {
    label: <OnlineOrderMenuItem/>,
    key: '6',
    path: '/online-orders',
    icon: <OnlineOrderMenuIcon />,
  },
  {
    label: <PurchaseOrderMenuLabel/>,
    key: '7',
    path: '/purchase-order',
    icon: <PurchaseOrderMenuIcon/>,
    children: [
      {
        label: translate('create_new_purchase_order'),
        key: 'purchase-order-new',
        path: '',
      },
      {
        label: translate('receive_purchase_order'),
        key: 'purchase-order-receive',
        path: '',
      },
      {
        label: (
          <MenuLink
            title={translate('back', 'order', 'listing')}
            to='/reports/back-order'
          />
        ),
        key: 'back-order',
        path: '',
      },
      {
        label: <ReceivedBackOrderMenuItem/>,
        key: 'received-back-orders',
        path: '',
      },
    ],
  },
  {
    label: translate("wedding_registry"),
    key: "8",
    path: "/wedding-registery",
    icon: <WeddingIcon size={23}/>,
  },
  {
    label: translate("upload", "inventory", "images"),
    key: "9",
    path: "/upload-images",
    icon: <CloudUploadOutlined style={{fontSize: 20, color: "#a3bde3"}}/>,
  },
  {
    label: translate("reports"),
    key: "10",
    icon: <BarChartOutlined style={{fontSize: 20, color: "#a3bde3"}}/>,
    children: [
      {
        label: (
          <MenuLink
            title={translate("order", "payments")}
            to="/reports/order-payments"
          />
        ),
        key: "orderPaymentsReport",
        path: "",
      },
      {
        label: (
          <MenuLink
            title={translate("sales", "by", "customer")}
            to="/reports/sales-by-customer"
          />
        ),
        key: "salesByCustomerReport",
        path: "",
      },
      {
        label: (
          <MenuLink
            title={translate("sales", "by", "vendor")}
            to="/reports/sales-by-vendor"
          />
        ),
        key: "salesByVendorReport",
        path: "",
      },
    
    
      {
        label: (
          <MenuLink
            title={translate("inventory", "by", "manufacture")}
            to="/reports/inventory-by-manufacture"
          />
        ),
        key: "inventory-by-manufacture",
        path: "",
      },
    ],
  },
  {
    label: <AppointmentMenuItem/>,
    key: "11",
    icon: <AppointmentMenuIcon/>,
  },
  {
    label: <TicketMenuItem/>,
    key: "12",
    icon: <TicketMenuIcon/>,
  },
  {
    label: translate("admin"),
    key: "13",
    icon: <ToolOutlined style={{fontSize: 20, color: "#a3bde3"}}/>,
    children: [
      {
        label: (
          <MenuLink
            title={translate("new_arrivals")}
            to="/admin/new-arrivals"
          />
        ),
        key: "new-arrivals",
        path: "",
      },
      {
        label: (
          <MenuLink
            title={translate("trending_jewelry")}
            to="/admin/trending-jewelry"
          />
        ),
        key: "trending-jewelry",
        path: "",
      },
      {
        label: (
          <MenuLink
            title={translate("trending_watch")}
            to="/admin/trending-watch"
          />
        ),
        key: "trending-watch",
        path: "",
      },
      {
        label: (
          <MenuLink title={translate("mass_changes")} to="/admin/mass-change"/>
        ),
        key: "mass-change",
        path: "",
      },
      {
        label: (
          <MenuLink
            title={translate('carousels')}
            to='/admin/carousels'
          />
        ),
        key: 'carousels',
        path: '',
      },
      {
        label: (
          <MenuLink
            title={translate('product_filters')}
            to='/admin/product-filters'
          />
        ),
        key: 'product-filters',
        path: '',
      },
      {
        label: (
          <MenuLink
            title={translate('shipping_methods')}
            to='/admin/shipping-methods'
          />
        ),
        key: 'shipping-methods',
        path: '',
      },
      {
        label: (
          <MenuLink
            title={translate('image_slider')}
            to='/admin/image-slider'
          />
        ),
        key: 'image-slider',
        path: '',
      },
      {
        label: (
          <MenuLink
            title={translate('banner')}
            to='admin/banner'
          />
        ),
        key: 'banner',
        path: '',
      }, 
      {
        label: (
          <MenuLink
            title={translate('blogs')}
            to='admin/blogs'
          />
        ),
        key: 'blogs',
        path: '',
        },
        {
          label: (
            <MenuLink
              title={translate('product', 'category', 'list')}
              to='admin/item-categories'
            />
          ),
          key: 'item-categories',
          path: '',
        },
        {
          label: (
            <MenuLink
              title={translate('online', 'payment')}
              to='/online-payments'
            />
          ),
          key: 'online-payments',
          path: '',
        }
      ],
  },
  {
    label: translate("settings"),
    key: "14",
    path: "/settings",
    icon: <SettingFilled style={{fontSize: 20, color: "#a3bde3"}}/>,
  },
];
